import MarkdownTextArea from './MarkdownTextArea';

export default MarkdownTextArea;



// WEBPACK FOOTER //
// ./src/components/MarkdownTextArea/index.ts